

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class ConfigurationService extends MainService {

  static findConfigurationCopyPasteInterpretation(params) {
    return this.postSEC(ServiceConstant.CONFIGURATION_FIND_ALLOW_COPY_PASTE_INTERPRETATION, params);
  }

  static findConfigurationOsirixPath(params) {
    return this.postSEC(ServiceConstant.CONFIGURATION_FIND_OSIRIX_PATH, params);
  }

}
